<template v-if="broadcast">
  <modal-notify :isFixed="true" @close="$emit('close')">
    <div slot="header">
      <v-layout>
        <v-flex style="position: absolute; right: 10px; top: 10px">
          <div @click="$emit('onClose')">
            <img src="/static/img/X.png" alt class="responsive-img pointer" style="height: 20px" />
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs10 sm10 md10>
          <slot name="editTitle"></slot>
        </v-flex>
      </v-layout>
    </div>

    <div slot="body">
      <div class="py-3">
        <slot name="input"> </slot>
      </div>
    </div>

    <div slot="footer" class="text-xs-center">
      <div class="pt-2" style="display: flex; justify-content: center">
        <Button outline :label="$t('cancel')" @click="$emit('onClose')" />
        <Button depressed :label="$t('Save')" @click="$emit('onSave')" />
      </div>
    </div>
  </modal-notify>
</template>
  
  <script>
import { mapGetters } from 'vuex'
import ModalNotify from '@/components/elements/ModalNotify'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import InputSearch from '@/components/elements/InputSearch.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'
export default {
  props: ['broadcast'],
  data: function () {
    return {
      name: '',
      broadcast: undefined,
      sendtype: 'promotion',
      pushtype: 'SILENT_PUSH', // REGULAR/SILENT_PUSH/NO_PUSH
      message: '',
      quick_reply: '',
      messages: [[]],
      update_status: '',
      update_tags: [],
    }
  },
  components: {
    ModalNotify,
    ScaleLoader,
    InputSearch,
    ToggleButton,
    Typography,
    Button,
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      linePushMessageCount: 'getLoadingLinePushMessageCount',
      loadingLinePushMessageCount: 'getLinePushMessageCount',
    }),
  },
  mounted: function () {
    var vm = this
    vm.name = vm.broadcast.name
  },
  methods: {
    onLoad: function () {
      var vm = this
      vm.loading = false
    },
  },
}
</script>
  
  <style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/broadcast/EditModal.vue